import api from './api';

export const wishesService = {
  // Get all wishes media for gallery
  getWishesGallery: async (params = {}) => {
    const response = await api.get('/wishes/gallery', { params });
    return response.data;
  },

  // Get specific media by ID
  getMediaById: async (id) => {
    const response = await api.get(`/wishes/media/${id}`);
    return response.data;
  },

  // Increment share count
  incrementShareCount: async (id) => {
    const response = await api.post(`/wishes/media/${id}/share`);
    return response.data;
  },

  // Increment download count
  incrementDownloadCount: async (id) => {
    const response = await api.post(`/wishes/media/${id}/download`);
    return response.data;
  },

  // Admin: Get all wishes media
  getAllWishesMedia: async () => {
    const response = await api.get('/wishes/admin/list');
    return response.data;
  },

  // Admin: Upload wishes media
  uploadWishesMedia: async (formData) => {
    const response = await api.post('/wishes/admin/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Admin: Update wishes media
  updateWishesMedia: async (id, data) => {
    const response = await api.put(`/wishes/admin/${id}`, data);
    return response.data;
  },

  // Admin: Delete wishes media
  deleteWishesMedia: async (id) => {
    const response = await api.delete(`/wishes/admin/${id}`);
    return response.data;
  }

  // Note: Video processing now happens in the browser using renderVideo.js
  // Backend processVideo API removed - no longer needed
};
